export default __webpack_public_path__ + "static/media/2.70c224b1.gif";